import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';
import { HttpClient } from '@angular/common/http';
import { ToastService } from './toast.service';
import { IMemoModel } from '../shared/models/memo.model';

@Injectable({
  providedIn: 'root'
})
export class MemosService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) { }

  deleteMemo(memoId: number): Observable<any> {
    return this.httpClient.delete(`${environment.api_base_url}memos/${memoId}`, {}).pipe(
      catchError((error) => {
        this.toastService.showError("Error deleting memo");
        return of({});
      })
    );
  }

  getMemos(filter: IMemoModel = { isActive: true }): Observable<IMemoModel[]> {
    return this.httpClient.post(`${environment.api_base_url}memos/search`, filter, {}).pipe(
      map((item: IResponse<IMemoModel[]>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || [];
      }),
      catchError((error) => {
        console.log(error);
        return of([]);
      })
    );
  }

  saveMemo(memo: IMemoModel): Observable<IMemoModel> {
    let obs;
    if (memo.id) {
      obs = this.httpClient.patch(`${environment.api_base_url}memos/${memo.id}`, memo, {})
    } else {
      obs = this.httpClient.post(`${environment.api_base_url}memos/create`, memo, {})
    }
    return obs.pipe(
      map((item: IResponse<IMemoModel>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || null;
      }),
      catchError((error) => {
        this.toastService.showError("Error saving memo");
        return of(null);
      })
    );
  }
}
